import { Component } from "react";
import { Button, Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import styles from "./VisibilitySelector.module.scss";
import VisibilityService from "../common/VisibilityService";
import { ModalComponentService } from "../common/ModalComponentService";
import i18n from "../i18n";
import type { ModalChildProps } from './ModalComponent';

interface VisibilitySelectorState {
  showHotels: boolean;
  showPOIs: boolean;
}

export default class VisibilitySelector extends Component<ModalChildProps, VisibilitySelectorState> {
  constructor(props: ModalChildProps) {
    super(props);

    this.state = {
      showHotels: VisibilityService.showHotels,
      showPOIs: VisibilityService.showPOIs,
    };

    this.handleHotels = this.handleHotels.bind(this);
    this.handlePOIs = this.handlePOIs.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount(): void {
    // needed to remove the aria-hidden error on render
    (document.activeElement as HTMLElement).blur();
  }

  handleHotels(event: React.ChangeEvent<HTMLInputElement>): void {
    const value = !!event.target.checked;
    this.setState({ showHotels: value });
    VisibilityService.setShowHotels(value);
  }

  handlePOIs(event: React.ChangeEvent<HTMLInputElement>): void {
    const value = !!event.target.checked;
    this.setState({ showPOIs: value });
    VisibilityService.setShowPOIs(value);
  }

  handleClose(): void {
    ModalComponentService.reset();
  }

  render() {
    return (
      <div className={styles.visibilitySelector}>
        <Typography variant="h5" component="h5">
          { i18n.t('visibilitySelector.title') }
        </Typography>

        <FormGroup className={styles.checkGroup}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={this.state.showHotels}
                onChange={this.handleHotels}
              />
            }
            label={ i18n.t('visibilitySelector.hotels') }
          />
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={this.state.showPOIs}
                onChange={this.handlePOIs}
              />
            }
            label={ i18n.t('visibilitySelector.pois') }
          />
        </FormGroup>

        <div className={styles.buttonsContainer}>
          <Button
            className={styles.button}
            variant="contained"
            color="primary"
            onClick={this.handleClose}
          >
            { i18n.t('visibilitySelector.accept') }
          </Button>
        </div>
      </div>
    );
  }
}

